export const NAME_REDUCER = 'coupon';

export const PREFIX_ACTIONS = 'coupon_feature_';

export const PATH_LOADING = {
  getData: `loading.${NAME_REDUCER}.getData`,
};

export enum COUPON_STATUS {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  EXPIRED = 'EXPIRED',
  USED = 'USED'
}

export enum COUPON_TYPE {
  PERCENTAGE = 'PERCENTAGE',
  FIXED_AMOUNT = 'FIXED_AMOUNT',
  FREE_ITEM = 'FREE_ITEM'
} 